import { lazy, Suspense } from "react";
import Header from "@/components/layout/Header";
import Hero from "@/components/sections/Hero";

const Footer = lazy(() => import("@/components/layout/Footer"));

const Problem = lazy(() => import("@/components/sections/Problem"));
const Solution = lazy(() => import("@/components/sections/Solution"));
const InstitutionTypes = lazy(() => import("@/components/sections/InstitutionTypes"));
const Benefits = lazy(() => import("@/components/sections/Benefits"));
const ContactForm = lazy(() => import("@/components/sections/ContactForm"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background" dir="rtl">
      <Header />
      <main>
        <Hero />
        <Suspense fallback={<div className="min-h-[200px]" />}>
          <Problem />
          <Solution />
          <InstitutionTypes />
          <Benefits />
          <ContactForm />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
